import React from "react";
import { useNavigate } from "react-router-dom";
import { brand } from "../../../../../config/brands";
import OrthoCheckLogo from "../../../../assets/images/orthocheck/orthocheck.svg";
import DentalCheckLogo from "../../../../assets/images/orthocheck/dentalcheck.svg";

const checkerLogo = brand.key === "mdp" ? DentalCheckLogo : OrthoCheckLogo;

const MedCheckBanner = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/orthocheck");
  };

  return (
    <div className="container">
      <div
        className="medcheck-banner-container p-5"
        style={{ backgroundColor: "#e6f6fe", borderRadius: "8px" }}
      >
        <style jsx>{`
          .medcheck-banner-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            gap: 20px;
          }

          .medcheck-banner-container > div {
            flex: 1;
            min-width: 200px;
          }

          .logo-section {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .text-section {
            text-align: left;
            flex: 2;
          }

          .button-section {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }

          @media (max-width: 992px) {
            .medcheck-banner-container {
              flex-direction: column;
              align-items: center;
              text-align: center;
              gap: 30px;
            }

            .logo-section,
            .text-section,
            .button-section {
              justify-content: center;
              text-align: center;
              width: 100%;
            }

            .medcheck-banner-container > div {
              flex: none;
              width: 100%;
              max-width: 100%;
            }

            .text-section {
              margin: 20px 0;
            }

            .button-section button {
              width: 100%;
              max-width: 300px;
            }
          }
          @media (max-width: 992px) {
            .medcheck-banner-container {
              flex-direction: column;
              align-items: center;
              text-align: center;
              gap: 30px;
            }

            .logo-section,
            .text-section,
            .button-section {
              justify-content: center;
              text-align: center;
              width: 100%;
            }

            .medcheck-banner-container > div {
              flex: none;
              min-width: auto;
              width: 100%;
            }

            .text-section {
              margin: 20px 0;
            }

            .button-section button {
              width: 100%;
              max-width: 300px;
            }
          }
        `}</style>

        <div className="logo-section">
          <img
            src={checkerLogo}
            alt={brand.checkerName}
            style={{ maxWidth: "200px", height: "auto" }}
            className="medchecklogo"
          />
        </div>

        <div className="text-section">
          <h3 className="h4 fw-semibold mb-2">
            In pain and ready to find out why?
          </h3>
          <p className="mb-0" style={{ color: "#34495e", fontSize: "1.1rem" }}>
            Try our free symptom checker for a probable diagnosis in minutes.
          </p>
        </div>

        <div className="button-section">
          <button
            className="button rounded px-4 py-3 fw-semibold"
            style={{ fontSize: "15px" }}
            onClick={handleButtonClick}
          >
            Get Your Probable <br /> Diagnosis Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedCheckBanner;
